import { Box, Typography } from '@material-ui/core'
import { Button, ContainerPage } from 'components'
import { DialogEdit, ReturnArea } from 'components/pages/Config/'
import { useConfig } from 'hooks/useConfig/Index'
import { useRef, useState, RefObject, useEffect } from 'react'
import { FaCog } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { ISettingsRequest } from 'services/settingsService'
import { IState } from 'store'

import { useStyles } from './styles'
import { animateValue } from 'utils/animateNumber'

export const LabelsPerBox = () => {
  const classes = useStyles()
  const ref: RefObject<HTMLElement> = useRef(null)
  const { updateSettings } = useConfig()
  const settings = useSelector<IState, ISettingsRequest>(state => state.settings)
  const [dialogEditStickersByBox, setDialogEditStickersByBox] = useState({
    isOpen: false,
    data: 0,
  })

  useEffect(() => {
    animateValue(ref.current as HTMLElement, 0, settings.stickersByBox, 2000)
  }, [settings.stickersByBox])

  return (
    <>
      <ContainerPage>
        <ReturnArea title="Etiquetas por Caixa" />

        <Box className={classes.boxAlign}>
          <Typography className={classes.titlePage}>Etiquetas por Caixa</Typography>

          <Button
            onClick={() => {
              setDialogEditStickersByBox({
                isOpen: true,
                data: settings.stickersByBox,
              })
            }}
            className={classes.configs}
          >
            <FaCog size={'1rem'} style={{ marginRight: '0.6rem' }} /> Editar
          </Button>
        </Box>

        <Box className={classes.containner}>
          <Typography className={classes.textWarning} ref={ref} />
          <Typography className={classes.textHelper}>Quantidade de etiquetas por caixa</Typography>
        </Box>
      </ContainerPage>

      <DialogEdit
        submit={updateSettings}
        setIsOpen={setDialogEditStickersByBox}
        title="Etiquetas por Caixa"
        field="stickersByBox"
        isOpen={dialogEditStickersByBox.isOpen}
        data={dialogEditStickersByBox.data}
        defaultValue={settings.stickersByBox}
      />
    </>
  )
}
